import { Leaf } from "lucide-react";
import { WHATSAPP_DISPLAY, buildWhatsAppUrl } from "../lib/api";

export default function Footer({ content = {} }) {
  const locationItems = (content.footer_location_items ||
    "Sierra de Veracruz\nA 7 min de Xico (pueblo mágico)\nA 10 min de Cañones de Pextlán\nAcceso por carretera pavimentada")
    .split("\n").filter(Boolean);

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050D08] text-[#F2EFE6]/80 border-t border-[#B8E07A]/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="w-10 h-10 rounded-full bg-gradient-to-br from-[#B8E07A] via-[#F1C36B] to-[#2C5135] flex items-center justify-center shadow-[0_0_20px_rgba(184,224,122,0.5)]">
              <Leaf className="w-5 h-5 text-[#0B1A0F]" strokeWidth={2.4} />
            </span>
            <div className="flex flex-col leading-tight">
              <span className="font-serif text-2xl text-[#F2EFE6]">{content.brand_name || "Pextlán"}</span>
              <span className="font-fairy text-base text-[#F1C36B] -mt-1">{content.brand_subtitle || "ecocomunidad"}</span>
            </div>
          </div>
          <p className="mt-4 text-sm leading-relaxed max-w-xs">
            {content.footer_about ||
              "14 lotes ecocampestres de 3,000 m² entre Xico y los Cañones de Pextlán. Tierra virgen, arroyo, mini-lago y 12 amenidades para vivir el cuento."}
          </p>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#F1C36B]">{content.footer_location_title || "Ubicación"}</div>
          <ul className="mt-4 space-y-2 text-sm">
            {locationItems.map((it, i) => (
              <li key={i}>{it}</li>
            ))}
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#F1C36B]">{content.footer_contact_title || "Contacto"}</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li>
              <a
                href={buildWhatsAppUrl(content.whatsapp_default_message || "Hola Pextlán, me gustaría más información de la ecocomunidad.")}
                target="_blank"
                rel="noreferrer"
                className="hover:text-[#B8E07A]"
              >
                WhatsApp: {WHATSAPP_DISPLAY}
              </a>
            </li>
            <li>{content.footer_contact_hours || "Lunes a sábado · 9:00 — 19:00"}</li>
            <li>{content.footer_contact_extra || "Recorridos guiados con cita previa"}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#B8E07A]/10">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-5 text-xs text-[#F2EFE6]/45 flex flex-wrap items-center justify-between gap-3">
          <span>© {new Date().getFullYear()} {content.footer_copyright || "Pextlán Ecocomunidad. Todos los derechos reservados."}</span>
          <a href="/admin" data-testid="admin-link" className="hover:text-[#F1C36B]">
            {content.footer_admin_link || "Acceso administrador"}
          </a>
        </div>
      </div>
    </footer>
  );
}
